import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import "./Sidebar.css";

/**
 * Sidebar — VS Code Explorer panel with a fake file tree.
 * Clicking a file navigates to the corresponding page.
 */

const FILES = [
  {
    name: "PORTFOLIO",
    children: [
      {
        name: "src",
        children: [
          { name: "pages", children: [
            { name: "index.js",   path: "/portfolio",        icon: "js" },
            { name: "projects.js",path: "/portfolio/projects", icon: "js" },
            { name: "about.js",   path: "/portfolio/about",    icon: "js" },
          ]},
          // { name: "components", children: [
          //   { name: "Navbar.jsx",      icon: "react" },
          //   { name: "ProjectCard.jsx", icon: "react" },
          //   { name: "SkillBadge.jsx",  icon: "react" },
          // ]},
          // { name: "data", children: [
          //   { name: "projects.js", icon: "js" },
          // ]},
          // { name: "i18n", children: [
          //   { name: "en.js", icon: "js" },
          //   { name: "fr.js", icon: "js" },
          // ]},
        ],
      },
      // { name: "package.json",   icon: "json" },
      // { name: "README.md",      icon: "md" },
      // { name: ".env",           icon: "env" },
    ],
  },
];

function Sidebar() {
  const { t } = useApp();
  const location = useLocation();

  const [open, setOpen] = useState({
    PORTFOLIO: true,
    src: true,
    pages: true,
    components: false,
    data: false,
    i18n: false,
  });

  const toggle = (name) =>
    setOpen((prev) => ({ ...prev, [name]: !prev[name] }));

  return (
    <div className="sidebar">
      <div className="sidebar__header">EXPLORER</div>
      <div className="sidebar__tree">
        {FILES.map((root) => (
          <TreeNode
            key={root.name}
            node={root}
            open={open}
            toggle={toggle}
            currentPath={location.pathname}
            depth={0}
          />
        ))}
      </div>

      {/* Outline section */}
      {/* <div className="sidebar__section-header">
        <ChevronIcon open={true} />
        OUTLINE
      </div>
      <div className="sidebar__outline">
        <span className="outline-item"><span className="outline-icon outline-icon--fn" />render()</span>
        <span className="outline-item"><span className="outline-icon outline-icon--const" />SKILLS</span>
        <span className="outline-item"><span className="outline-icon outline-icon--fn" />HomePage()</span>
      </div> */}
    </div>
  );
}

function TreeNode({ node, open, toggle, currentPath, depth }) {
  const isFolder = !!node.children;
  const isOpen = open[node.name];
  
  const indent = depth * 12;
  
  if (isFolder) {
    return (
      <div className="tree-folder">
        <button
          className="tree-row tree-row--folder"
          style={{ paddingLeft: 8 + indent }}
          onClick={() => toggle(node.name)}
        >
          <ChevronIcon open={isOpen} />
          <FolderIcon open={isOpen} />
          <span className="tree-name">{node.name}</span>
        </button>
        {isOpen && (
          <div className="tree-children">
            {node.children.map((child) => (
              <TreeNode
                key={child.name}
                node={child}
                open={open}
                toggle={toggle}
                currentPath={currentPath}
                depth={depth + 1}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
  
  const content = (
    <>
      <FileIcon type={node.icon} />
      <span className="tree-name">{node.name}</span>
    </>
  );

  const isActive =
    node.path === "/portfolio"
      ? currentPath === "/portfolio"
      : node.path && currentPath.startsWith(node.path);

  if (node.path) {
    return (
      <NavLink
        to={node.path}
        end={node.path === "/"}
        className={
          `tree-row tree-row--file${isActive ? " tree-row--active" : ""}`
        }
        style={{ paddingLeft: 20 + indent }}
      >
        {content}
      </NavLink>
    );
  }

  return (
    <div className="tree-row tree-row--file" style={{ paddingLeft: 8 + indent }}>
      {content}
    </div>
  );
}

/* ── Icons ───────────────────────────────────────────────────────── */
function ChevronIcon({ open }) {
  return (
    <svg
      width="16" height="16" viewBox="0 0 16 16" fill="currentColor"
      className={`chevron${open ? " chevron--open" : ""}`}
    >
      <path d="M6 4l4 4-4 4V4z"/>
    </svg>
  );
}

function FolderIcon({ open }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="file-icon">
      {open ? (
         <path transform="scale(0.008)" d="m572.501 747-254.933 815.893-101.867-31.786 278.507-890.774h1105.813v-320H783.808L612.181 107H.021v1546.667c0 88.213 71.787 160 160 160h1388.054c75.946 0 141.973-54.08 156.906-128.64L1892.608 747H572.501Z" fill="#dcb67a"/>

      ) : (
        <path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h3.586a1 1 0 0 1 .707.293l.707.707H13.5A1.5 1.5 0 0 1 15 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 11.5v-8z" fill="#dcb67a"/>
      )}
    </svg>
  );
}

const EXT_COLORS = {
  react: "#61dafb",
  js:    "#f7df1e",
  json:  "#f7df1e",
  md:    "#519aba",
  env:   "#8bc34a",
  css:   "#519aba",
};

const EXT_LETTERS = {
  react: "R", js: "JS", json: "{}", md: "M", env: "E", css: "C", 
};

function FileIcon({ type = "js" }) {
  return (
    <span
      className="file-icon-badge"
      style={{ color: EXT_COLORS[type] || "#d4d4d4" }}
    >
      {EXT_LETTERS[type] || "F"}
    </span>
  );
}

export default Sidebar;
